module.exports = __webpack_public_path__ + "static/iosButton-1b65926236d951b2af57201b275f595b.svg";